package br.com.texeratx.boardgametimeapp.domain.usecases.upload

import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository

class UploadExpansionImageUseCase(
    private val repo: UploadRepository
) {
    suspend operator fun invoke(
        bytes: ByteArray,
        fileName: String,
        mimeType: String?
    ): Result<String> {
        val safeMimeType = mimeType ?: "image/jpeg"
        return repo.uploadExpansionImage(bytes, fileName, safeMimeType)
    }
}